export const getFullName = user => {
  if (!user) return '';
  // Set when the user's record can't be read: a pending invitee (whose record stays private until they accept), or
  // someone who has left every profile the reader is on. Invitees carry the name they were invited with, if any.
  if (user.isUnavailable) {
    const invitedName = [user.firstname, user.lastname].filter(Boolean).join(' ');
    if (invitedName) return invitedName;
    return user.isPendingInvite ? 'Invited team member' : 'Team member';
  }
  return `${user.firstname} ${user.lastname}`;
};

export default getFullName;
